import React, { useState } from 'react';
import { NextUI } from '@/components/NextUI';
import Button from '@/components/NextUI/Button';
import FormCard from '../../../../components/Layouts/Default/FormCard';
import { useTranslations } from 'next-intl';

const AddUserModal: React.FC = () => {
  const t = useTranslations('modals.add_user');
  const [email, setEmail] = useState<string>('');

  return (
    <NextUI.Modal
      className="max-w-[500px]"
      classNames={{ content: 'py-8 !px-4 md:!px-8' }}
      defaultOpen={true}
      name={'AddUserModal'}
    >
      <h2 className="h5 font-semibold text-start text-dark">{t('title')}</h2>

      <FormCard
        isAction={false}
        className="mt-[22px]"
        classNames={{
          actionButton: 'max-w-[160px]',
          actionWrapper: 'inline-flex flex-col items-end p-0',
          formBody: 'p-0',
        }}
      >
        <NextUI.Input
          type="email"
          formNoValidate
          variant="outline"
          radius="sm"
          placeholder={t('email_placeholder')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <p className="text-gray-dark text-sm mt-6">{t('description')}</p>

        <div className="flex justify-end gap-4 mt-8">
          <Button variant="outline" className="w-[160px]">
            {t('buttons.cancel')}
          </Button>

          <Button className="w-[160px]">{t('buttons.add_user')}</Button>
        </div>
      </FormCard>
    </NextUI.Modal>
  );
};

export default AddUserModal;
